export default __webpack_public_path__ + "static/media/ketosis_shortcut@2x.9d8b5054.jpg";